import { Button } from '@/components/ui/button';
import useGeneratorStore, { GeneratorTypeEnums, R3imagineStatusType } from '@/state/generator-store';
import useFlags from '@jenmusic/feature-flag';
import React from 'react';
import { GradientButton } from '../AudioEditor/EditorButton';
import { CloseIcon, PromiseIcon } from '@/components/Icons';

interface ConditionConfirmProps {
  disabled: boolean;
  hide?: () => void;
}

const ConditionConfirm: React.FC<ConditionConfirmProps> = ({ disabled, hide }) => {
  const { setR3ImageStatus, setGeneratorType } = useGeneratorStore();

  const { showNewGenerator } = useFlags();

  if (showNewGenerator) {
    return (
      <div className={`bg-[#191A1B] rounded-md p-1 flex flex-col ${disabled ? 'pointer-events-none' : ''}`}>
        <div className={`${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
          <div className="bg-[#383A3C] rounded-md p-1 h-[340px]">
            <div className="bg-[#191A1B] rounded-md p-1 flex-1 h-full">
              <div className="bg-jen-orange py-4 px-6 rounded-md h-full">
                <div className="w-full">
                  <h2 className="text-xl font-bold mb-2 text-[#111112]">I promise that I didn't steal this music.</h2>
                  <p className="text-lg text-[#111112]">
                    I read the Jen&nbsp;
                    <a className={'underline'} target="_blank" href={`https://www.jenmusic.ai/terms-of-use`}>
                      Terms and Conditions
                    </a>
                    &nbsp;and I reconfirm my agreement to those terms.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center h-[72px] items-center mt-1">
            <GradientButton
              type="button"
              className="text-[#111112] hover:bg-orange-600 border border-[#111112] radius-xs"
              onClick={() => setR3ImageStatus(R3imagineStatusType.WaitingUpload)}
              text="CANCEL"
              icon={<CloseIcon />}
              width="25%"
            />
            <GradientButton
              type="button"
              className="bg-black text-white hover:bg-gray-800 radius-xs ml-1"
              onClick={() => {
                hide?.();
                setGeneratorType(GeneratorTypeEnums.R3IMAGINE);
                setR3ImageStatus(R3imagineStatusType.WaitingGenerate);
              }}
              text="I PROMISE"
              width="75%"
              icon={<PromiseIcon />}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-[#191A1B] rounded-md p-1 h-full ${disabled ? 'pointer-events-none' : ''}`}>
      <div className={`h-full ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
        <div className="bg-[#383A3C] rounded-md p-1 h-full">
          <div className="bg-[#191A1B] rounded-md p-1 h-full">
            <div className="bg-jen-orange py-4 px-6 rounded-md h-full flex flex-col justify-between">
              <div className="mb-4 w-full">
                <h2 className="text-xl font-bold mb-2 text-[#111112]">I promise that I didn't steal this music.</h2>
                <p className="text-lg text-[#111112]">
                  I read the Jen&nbsp;
                  <a className={'underline'} target="_blank" href={`https://www.jenmusic.ai/terms-of-use`}>
                    Terms and Conditions
                  </a>
                  &nbsp;and I reconfirm my agreement to those terms.
                </p>
              </div>
              <div className="flex justify-center space-x-4">
                <Button
                  variant="default"
                  type="button"
                  className="bg-black text-white hover:bg-gray-800 radius-xs"
                  onClick={() => {
                    setR3ImageStatus(R3imagineStatusType.WaitingGenerate);
                  }}
                >
                  I PROMISE
                </Button>
                <Button
                  variant="ghost"
                  type="button"
                  className="text-[#111112] hover:bg-orange-600 border border-[#111112] radius-xs"
                  onClick={() => setR3ImageStatus(R3imagineStatusType.WaitingUpload)}
                >
                  CANCEL
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionConfirm;
